import { Component, computed, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Session, SessionErrorDetails, SessionStatus } from '../../../shared/models/session.model';
import { SessionErrorDetailsUtils } from '../../../shared/services/session-error-details-utils';

@Component({
  standalone: false,
  selector: 'app-session-supplier-table-status-cell',
  templateUrl: './session-supplier-table-status-cell.component.html',
  styleUrl: './session-supplier-table-status-cell.component.scss',
  host: {
    class: 'w-100',
  },
})
export class SessionSupplierTableStatusCellComponent implements ICellRendererAngularComp {
  readonly cellData = signal<Session | null>(null);

  // computed
  readonly errorDetails = computed<SessionErrorDetails | null>(() => {
    if (!this.cellData() || this.cellData()?.online) return null;
    const errorDetails = this.cellData() ? SessionErrorDetailsUtils.buildErrorDetails(this.cellData()!) : null;
    return errorDetails;
  });

  readonly isReconnecting = computed(() => this.cellData()?.statusCode === SessionStatus.RECONNECTING);

  agInit(params: ICellRendererParams<Session>): void {
    this.setData(params);
  }

  refresh(params: ICellRendererParams<Session>): boolean {
    this.setData(params);
    return true;
  }

  private setData(params: ICellRendererParams<Session>) {
    this.cellData.set(params.data!);
  }
}
